import { AddNewNodeIcon, DeleteIcon, ColorPickerIcon, UndoIcon, RedoIcon, HomeIcon, ExportIcon, SaveIcon, ShareIcon } from './icons';

const Menu = ({
  handleAddChildNode,
  handleRemoveNode,
  handleUndo = () => {},
  handleRedo = () => {},
  setShowPicker,
  showPicker,
  isDarkMode,
  canUndo = () => false,
  canRedo = () => false,
  showHome,
  onHome,
  onExport,
  onExportData,
  onShare,
  canWrite = true,
}) => {

    const buttonStyle = {
        background: 'transparent',
        border: 'none',
        padding: 2,
        marginBottom: 30,

        cursor: 'pointer',
        outline: 'none',
        color: isDarkMode ? '#fff' : '#000',
        fontSize: 19,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
    return (
        <div
          style={{
            backgroundColor: isDarkMode
              ? 'rgba(45, 45, 45, 0.7)'
              : 'rgba(255, 255, 255, 0.7)',
            borderRadius: 15,
            padding: 10,
          }}
          onClick={(e) => e.stopPropagation()}
          onPointerDown={(e) => e.stopPropagation()}
          onPointerUp={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
        >
        {showHome && onHome && (
          <button onClick={onHome} style={{ ...buttonStyle, marginTop: 20 }}>
            <HomeIcon />
          </button>
        )}
        <button
          disabled={!canWrite}
          onClick={handleAddChildNode}
          style={{ ...buttonStyle, marginTop: showHome ? 0 : 20 }}
          title="Add child (Tab)"
        >
          <AddNewNodeIcon/>
        </button>
        <button disabled={!canWrite} onClick={handleRemoveNode} style={buttonStyle}><DeleteIcon/></button>
        <button
          onClick={handleUndo}
          disabled={!canWrite || !canUndo()}
          style={buttonStyle}
          title="Undo (Ctrl/Cmd+Z)"
          aria-label="Undo"
        >
          <UndoIcon />
        </button>
        <button
          onClick={handleRedo}
          disabled={!canWrite || !canRedo()}
          style={buttonStyle}
          title="Redo (Ctrl/Cmd+Shift+Z)"
          aria-label="Redo"
        >
          <RedoIcon />
        </button>
        <button disabled={!canWrite} onClick={() => setShowPicker(!showPicker)} style={buttonStyle}><ColorPickerIcon /></button>
        {onExport && (
          <button onClick={onExport} style={buttonStyle} title="Export as PNG image">
            <ExportIcon />
          </button>
        )}
        {onExportData && (
          <button
            onClick={onExportData}
            style={buttonStyle}
            title="Export map as JSON"
            aria-label="Export map"
          >
            <SaveIcon />
          </button>
        )}
        {onShare && (
          <button
            onClick={onShare}
            style={buttonStyle}
            title="Share map"
            aria-label="Share map"
          >
            <ShareIcon />
          </button>
        )}
        </div>
        )

}

export default Menu;
